import Dexie from 'dexie'



export const db = new Dexie('caixamestre')



db.version(1).stores({

  users: 'id, login, perfil, ativo',

  auditLogs: 'id, dataHora, usuarioId, acao, tabelaAfetada, registroId',

  settings: 'key'

})



db.version(2).stores({

  users: 'id, login, perfil, ativo',

  auditLogs: 'id, dataHora, usuarioId, acao, tabelaAfetada, registroId',

  settings: 'key',

  produtos: 'id, tipo, nome, codigo, status, criadoEm',

  funcionarios: 'id, nome, matricula, status, criadoEm',

  movimentacoes: 'id, dataMovimentacao, funcionarioId, produtoId, tipoMovimentacao, status',

  pedidosAtivo: 'id, dataInicio',

  pedidosArquivados: 'id, numero, dataEnvio'

})



db.version(3)

  .stores({

    users: 'id, login, perfil, ativo',

    auditLogs: 'id, dataHora, usuarioId, acao, tabelaAfetada, registroId',

    settings: 'key',

    produtos: 'id, tipo, reutilizavel, nome, codigo, status, criadoEm',

    funcionarios: 'id, nome, matricula, status, criadoEm',

    movimentacoes: 'id, dataMovimentacao, funcionarioId, produtoId, tipoMovimentacao, status',

    pedidosAtivo: 'id, dataInicio',

    pedidosArquivados: 'id, numero, dataEnvio'

  })

  .upgrade(async (tx) => {

    const produtos = tx.table('produtos')

    await produtos.toCollection().modify((p) => {

      if (p.tipo === 'epi-pessoal') {

        p.tipo = 'epi'

        p.reutilizavel = false

      } else if (p.tipo === 'epi-reutilizavel') {

        p.tipo = 'epi'

        p.reutilizavel = true

      } else if (p.tipo === 'epi') {

        if (typeof p.reutilizavel !== 'boolean') p.reutilizavel = false

      }

    })

  })



// Versão 4: Adiciona contadores para numeração sequencial

db.version(4)

  .stores({

    users: 'id, login, perfil, ativo',

    auditLogs: 'id, dataHora, usuarioId, acao, tabelaAfetada, registroId',

    settings: 'key',

    produtos: 'id, tipo, reutilizavel, nome, codigo, status, criadoEm',

    funcionarios: 'id, nome, matricula, status, criadoEm',

    movimentacoes: 'id, dataMovimentacao, funcionarioId, produtoId, tipoMovimentacao, status, devolucaoTipo, quantidade, quantidadeDevolvida, quantidadeManutencao',

    pedidosAtivo: 'id, dataInicio',

    pedidosArquivados: 'id, numero, dataEnvio',

    counters: 'id'

  })

  .upgrade(async (tx) => {

    const movs = tx.table('movimentacoes')

    await movs.toCollection().modify((m) => {

      if (typeof m.devolucaoTipo === 'undefined') m.devolucaoTipo = null

      if (typeof m.dataDevolucaoReal === 'undefined') m.dataDevolucaoReal = null

    })
  })


// Versão 5: Adiciona foto nos produtos, fotoEntrega e assinatura nas movimentações
db.version(5)
  .stores({
    users: 'id, login, perfil, ativo',
    auditLogs: 'id, dataHora, usuarioId, acao, tabelaAfetada, registroId',
    settings: 'key',
    produtos: 'id, tipo, reutilizavel, nome, codigo, status, criadoEm',
    funcionarios: 'id, nome, matricula, status, criadoEm',
    movimentacoes: 'id, dataMovimentacao, funcionarioId, produtoId, tipoMovimentacao, status, devolucaoTipo',
    pedidosAtivo: 'id, dataInicio',
    pedidosArquivados: 'id, numero, dataEnvio',
    counters: 'id',
    backups: 'id, dataCriacao'
  })


// Versão 6: Adiciona tabelas para módulo de compras (multiusuário)
db.version(6)
  .stores({
    users: 'id, login, perfil, ativo',
    auditLogs: 'id, dataHora, usuarioId, acao, tabelaAfetada, registroId',
    settings: 'key',
    produtos: 'id, tipo, reutilizavel, nome, codigo, status, criadoEm',
    funcionarios: 'id, nome, matricula, status, criadoEm',
    movimentacoes: 'id, dataMovimentacao, funcionarioId, produtoId, tipoMovimentacao, status, devolucaoTipo',
    pedidosAtivo: 'id, dataInicio',
    pedidosArquivados: 'id, numero, dataEnvio',
    counters: 'id',
    backups: 'id, dataCriacao',
    comprasPendentes: 'id, numero, dataEnvio, status, usuarioId',
    historicoCompras: 'id, numero, dataFinalizacao, status, usuarioId'
  })

// Versão 7: Adiciona historicoPedidos para rastrear pedidos enviados
db.version(7)
  .stores({
    users: 'id, login, perfil, ativo',
    auditLogs: 'id, dataHora, usuarioId, acao, tabelaAfetada, registroId',
    settings: 'key',
    produtos: 'id, tipo, reutilizavel, nome, codigo, status, criadoEm',
    funcionarios: 'id, nome, matricula, status, criadoEm',
    movimentacoes: 'id, dataMovimentacao, funcionarioId, produtoId, tipoMovimentacao, status, devolucaoTipo',
    pedidosAtivo: 'id, dataInicio',
    pedidosArquivados: 'id, numero, dataEnvio',
    counters: 'id',
    backups: 'id, dataCriacao',
    comprasPendentes: 'id, numero, dataEnvio, status, usuarioId',
    historicoCompras: 'id, numero, dataFinalizacao, status, usuarioId',
    historicoPedidos: 'id, numero, dataFinalizacao, status, usuarioId'
  })

// Versão 8: Adiciona pendingSync para rastrear itens pendentes de sincronização
db.version(8)
  .stores({
    users: 'id, login, perfil, ativo',
    auditLogs: 'id, dataHora, usuarioId, acao, tabelaAfetada, registroId',
    settings: 'key',
    produtos: 'id, tipo, reutilizavel, nome, codigo, status, criadoEm, pendingSync',
    funcionarios: 'id, nome, matricula, status, criadoEm',
    movimentacoes: 'id, dataMovimentacao, funcionarioId, produtoId, tipoMovimentacao, status, devolucaoTipo, pendingSync',
    pedidosAtivo: 'id, dataInicio',
    pedidosArquivados: 'id, numero, dataEnvio',
    counters: 'id',
    backups: 'id, dataCriacao',
    comprasPendentes: 'id, numero, dataEnvio, status, usuarioId',
    historicoCompras: 'id, numero, dataFinalizacao, status, usuarioId',
    historicoPedidos: 'id, numero, dataFinalizacao, status, usuarioId'
  })
  .upgrade(async (tx) => {
    // Inicializar pendingSync como 0 (sincronizado) para todos os itens existentes
    const produtos = tx.table('produtos')
    const movimentacoes = tx.table('movimentacoes')
    
    await produtos.toCollection().modify((p) => {
      if (typeof p.pendingSync === 'undefined') p.pendingSync = 0
    })
    
    await movimentacoes.toCollection().modify((m) => {
      if (typeof m.pendingSync === 'undefined') m.pendingSync = 0
    })
  })

// Versão 9: Adiciona pendingSync em comprasPendentes
db.version(9)
  .stores({
    users: 'id, login, perfil, ativo',
    auditLogs: 'id, dataHora, usuarioId, acao, tabelaAfetada, registroId',
    settings: 'key',
    produtos: 'id, tipo, reutilizavel, nome, codigo, status, criadoEm, pendingSync',
    funcionarios: 'id, nome, matricula, status, criadoEm',
    movimentacoes: 'id, dataMovimentacao, funcionarioId, produtoId, tipoMovimentacao, status, devolucaoTipo, pendingSync',
    pedidosAtivo: 'id, dataInicio',
    pedidosArquivados: 'id, numero, dataEnvio',
    counters: 'id',
    backups: 'id, dataCriacao',
    comprasPendentes: 'id, numero, dataEnvio, status, usuarioId, pendingSync',
    historicoCompras: 'id, numero, dataFinalizacao, status, usuarioId',
    historicoPedidos: 'id, numero, dataFinalizacao, status, usuarioId'
  })
  .upgrade(async (tx) => {
    // Inicializar pendingSync como 0 para compras existentes
    const comprasPendentes = tx.table('comprasPendentes')
    
    await comprasPendentes.toCollection().modify((c) => {
      if (typeof c.pendingSync === 'undefined') c.pendingSync = 0
    })
  })

// Versão 10: Adiciona pendingSync em todas as tabelas para sincronização completa
db.version(10)
  .stores({
    users: 'id, login, perfil, ativo',
    auditLogs: 'id, dataHora, usuarioId, acao, tabelaAfetada, registroId',
    settings: 'key',
    produtos: 'id, tipo, reutilizavel, nome, codigo, status, criadoEm, pendingSync',
    funcionarios: 'id, nome, matricula, status, criadoEm',
    movimentacoes: 'id, dataMovimentacao, funcionarioId, produtoId, tipoMovimentacao, status, devolucaoTipo, pendingSync',
    pedidosAtivo: 'id, dataInicio',
    pedidosArquivados: 'id, numero, dataEnvio',
    counters: 'id',
    backups: 'id, dataCriacao',
    comprasPendentes: 'id, numero, dataEnvio, status, usuarioId, pendingSync',
    historicoCompras: 'id, numero, dataFinalizacao, status, usuarioId',
    historicoPedidos: 'id, numero, dataFinalizacao, status, usuarioId'
  })

// Versão 11: Adiciona campos de localização no almoxarifado (v4.0.0)
db.version(11)
  .stores({
    users: 'id, login, perfil, ativo',
    auditLogs: 'id, dataHora, usuarioId, acao, tabelaAfetada, registroId',
    settings: 'key',
    // Adiciona índices de localização para busca eficiente
    produtos: 'id, tipo, reutilizavel, nome, codigo, status, criadoEm, pendingSync, localizacao, locCorredor, locPrateleira, locGaveta',
    funcionarios: 'id, nome, matricula, status, criadoEm',
    movimentacoes: 'id, dataMovimentacao, funcionarioId, produtoId, tipoMovimentacao, status, devolucaoTipo, pendingSync',
    pedidosAtivo: 'id, dataInicio',
    pedidosArquivados: 'id, numero, dataEnvio',
    counters: 'id',
    backups: 'id, dataCriacao',
    comprasPendentes: 'id, numero, dataEnvio, status, usuarioId, pendingSync',
    historicoCompras: 'id, numero, dataFinalizacao, status, usuarioId',
    historicoPedidos: 'id, numero, dataFinalizacao, status, usuarioId'
  })
  .upgrade(async (tx) => {
    // Inicializar campos de localização como null para produtos existentes
    const produtos = tx.table('produtos')
    
    await produtos.toCollection().modify((p) => {
      if (typeof p.localizacao === 'undefined') p.localizacao = null
      if (typeof p.locCorredor === 'undefined') p.locCorredor = null
      if (typeof p.locPrateleira === 'undefined') p.locPrateleira = null
      if (typeof p.locGaveta === 'undefined') p.locGaveta = null
      if (typeof p.locObservacao === 'undefined') p.locObservacao = null
    })
  })

// Versão 12: Centro de Custo por Obra + pendingSync completo
db.version(12)
  .stores({
    users: 'id, login, perfil, ativo, pendingSync',
    auditLogs: 'id, dataHora, usuarioId, acao, tabelaAfetada, registroId, pendingSync',
    settings: 'key, pendingSync',
    produtos: 'id, tipo, reutilizavel, nome, codigo, status, criadoEm, pendingSync',
    funcionarios: 'id, nome, matricula, status, criadoEm, pendingSync',
    // Adiciona obra_id em movimentacoes
    movimentacoes: 'id, dataMovimentacao, funcionarioId, produtoId, tipoMovimentacao, status, devolucaoTipo, obraId, pendingSync',
    // Nova tabela: obras
    obras: 'id, nome, codigo, status, empresaId, criadoEm, pendingSync',
    pedidosAtivo: 'id, dataInicio, obraId, pendingSync',
    pedidosArquivados: 'id, numero, dataEnvio, pendingSync',
    counters: 'id, pendingSync',
    backups: 'id, dataCriacao',
    comprasPendentes: 'id, numero, dataEnvio, status, usuarioId, pendingSync',
    historicoCompras: 'id, numero, dataFinalizacao, status, usuarioId, pendingSync',
    historicoPedidos: 'id, numero, dataFinalizacao, status, usuarioId, pendingSync'
  })
  .upgrade(async (tx) => {
    // Inicializar pendingSync em todas as tabelas
    const tabelas = ['users', 'auditLogs', 'settings', 'funcionarios', 'pedidosAtivo', 'pedidosArquivados', 'counters', 'historicoCompras', 'historicoPedidos']
    
    for (const nomeTabela of tabelas) {
      const tabela = tx.table(nomeTabela)
      await tabela.toCollection().modify((item) => {
        if (typeof item.pendingSync === 'undefined') item.pendingSync = 0
      })
    }
    
    // Inicializar obraId como null em movimentacoes existentes
    const movimentacoes = tx.table('movimentacoes')
    await movimentacoes.toCollection().modify((m) => {
      if (typeof m.obraId === 'undefined') m.obraId = null
    })
    
    // Inicializar obraId como null em pedidosAtivo existentes
    const pedidosAtivo = tx.table('pedidosAtivo')
    await pedidosAtivo.toCollection().modify((p) => {
      if (typeof p.obraId === 'undefined') p.obraId = null
    })
  })

// Versão 13: Notas Fiscais + vinculação em produtos
db.version(13)
  .stores({
    users: 'id, login, perfil, ativo, pendingSync',
    auditLogs: 'id, dataHora, usuarioId, acao, tabelaAfetada, registroId, pendingSync',
    settings: 'key, pendingSync',
    produtos: 'id, tipo, reutilizavel, nome, codigo, status, criadoEm, notaFiscalId, pendingSync',
    funcionarios: 'id, nome, matricula, status, criadoEm, pendingSync',
    movimentacoes: 'id, dataMovimentacao, funcionarioId, produtoId, tipoMovimentacao, status, devolucaoTipo, obraId, pendingSync',
    obras: 'id, nome, codigo, status, empresaId, criadoEm, pendingSync',
    pedidosAtivo: 'id, dataInicio, obraId, pendingSync',
    pedidosArquivados: 'id, numero, dataEnvio, pendingSync',
    counters: 'id, pendingSync',
    backups: 'id, dataCriacao',
    comprasPendentes: 'id, numero, dataEnvio, status, usuarioId, pendingSync',
    historicoCompras: 'id, numero, dataFinalizacao, status, usuarioId, pendingSync',
    historicoPedidos: 'id, numero, dataFinalizacao, status, usuarioId, pendingSync',
    notasFiscais: 'id, numero, fornecedorNome, dataEmissao, empresaId, criadoEm, pendingSync'
  })
  .upgrade(async (tx) => {
    // Inicializar notaFiscalId como null em produtos existentes
    const produtos = tx.table('produtos')
    await produtos.toCollection().modify((p) => {
      if (typeof p.notaFiscalId === 'undefined') p.notaFiscalId = null
    })
  })

export async function getNextOrderNumber() {
  const now = new Date()
  const dd = String(now.getDate()).padStart(2, '0')
  const mm = String(now.getMonth() + 1).padStart(2, '0')
  const yy = String(now.getFullYear()).slice(-2)
  const hh = String(now.getHours()).padStart(2, '0')
  const min = String(now.getMinutes()).padStart(2, '0')
  return `PED-${dd}${mm}${yy}-${hh}${min}`
}

export async function ensureSeedData() {

  const existing = await db.users.where('login').equals('admin').first()

  if (!existing) {

    await db.users.add({

      id: crypto.randomUUID(),

      nome: 'Administrador',

      login: 'admin',

      senhaHash: await hashPassword('7465'),

      perfil: 'admin',

      ativo: true,

      perguntaSeguranca: 'Qual o nome da sua mãe?',

      respostaSegurancaHash: await hashText('admin'),

      ultimoAcesso: null,

      tentativasLogin: 0,

      criadoEm: Date.now()

    })

  }

  

  // Importar dados iniciais se o banco estiver vazio

  await importInitialData()

}



async function importInitialData() {

  try {

    // Verificar se já existem produtos (se sim, dados já foram importados)

    const produtosCount = await db.produtos.count()

    if (produtosCount > 0) return

    

    // Disparar evento de início da importação

    window.dispatchEvent(new CustomEvent('dataImportStart', { 

      detail: { message: 'Iniciando importação de dados...' } 

    }))

    

    // Buscar arquivo de dados iniciais

    const response = await fetch('./dados_importar.json')

    if (!response.ok) {

      const msg = 'Arquivo dados_importar.json não encontrado, pulando importação inicial'

      console.log(msg)

      window.dispatchEvent(new CustomEvent('dataImportWarning', { 

        detail: { message: msg } 

      }))

      return

    }

    

    const data = await response.json()

    

    // Disparar evento de progresso

    window.dispatchEvent(new CustomEvent('dataImportProgress', { 

      detail: { message: 'Processando arquivo de dados...' } 

    }))

    

    let produtosImportados = 0

    let funcionariosImportados = 0

    let movimentacoesImportadas = 0

    

    await db.transaction('rw', db.produtos, db.funcionarios, db.movimentacoes, async () => {

      if (data.produtos?.length) {

        await db.produtos.bulkPut(data.produtos)

        produtosImportados = data.produtos.length

        window.dispatchEvent(new CustomEvent('dataImportProgress', { 

          detail: { message: `Importando ${produtosImportados} produtos...` } 

        }))

      }

      if (data.funcionarios?.length) {

        await db.funcionarios.bulkPut(data.funcionarios)

        funcionariosImportados = data.funcionarios.length

        window.dispatchEvent(new CustomEvent('dataImportProgress', { 

          detail: { message: `Importando ${funcionariosImportados} funcionários...` } 

        }))

      }

      if (data.movimentacoes?.length) {

        await db.movimentacoes.bulkPut(data.movimentacoes)

        movimentacoesImportadas = data.movimentacoes.length

        window.dispatchEvent(new CustomEvent('dataImportProgress', { 

          detail: { message: `Importando ${movimentacoesImportadas} movimentações...` } 

        }))

      }

    })

    

    const successMsg = `Dados importados com sucesso! ${produtosImportados} produtos, ${funcionariosImportados} funcionários, ${movimentacoesImportadas} movimentações`

    console.log(successMsg)

    window.dispatchEvent(new CustomEvent('dataImportSuccess', { 

      detail: { 

        message: successMsg,

        produtos: produtosImportados,

        funcionarios: funcionariosImportados,

        movimentacoes: movimentacoesImportadas

      } 

    }))

  } catch (err) {

    const errorMsg = `Erro ao importar dados: ${err?.message || 'Erro desconhecido'}`

    console.error('Erro ao importar dados iniciais:', err)

    window.dispatchEvent(new CustomEvent('dataImportError', { 

      detail: { message: errorMsg, error: err } 

    }))

  }

}



export async function hashText(text) {

  const enc = new TextEncoder().encode(text)

  const digest = await crypto.subtle.digest('SHA-256', enc)

  return bufferToHex(digest)

}



export async function hashPassword(password) {

  return hashText(password)

}



export async function verifyPassword(password, passwordHash) {

  const h = await hashPassword(password)

  return timingSafeEqual(h, passwordHash)

}



export async function verifySecurityAnswer(answer, answerHash) {

  const h = await hashText(answer)

  return timingSafeEqual(h, answerHash)

}



function bufferToHex(buffer) {

  return [...new Uint8Array(buffer)].map(b => b.toString(16).padStart(2, '0')).join('')

}



function timingSafeEqual(a, b) {

  if (typeof a !== 'string' || typeof b !== 'string') return false

  if (a.length !== b.length) return false

  let out = 0

  for (let i = 0; i < a.length; i++) out |= a.charCodeAt(i) ^ b.charCodeAt(i)

  return out === 0

}

// ============= PRODUTOS (para compatibilidade com hybridDb) =============

export async function listProdutos({ q = '', tipo = 'todos', status = 'ativo' } = {}) {
  let query = db.produtos.toCollection()
  
  if (status !== 'todos') {
    query = query.filter(p => p.status === status)
  }
  if (tipo !== 'todos') {
    query = query.filter(p => p.tipo === tipo)
  }
  
  let produtos = await query.toArray()
  
  if (q) {
    const termo = q.toLowerCase()
    produtos = produtos.filter(p =>
      p.nome?.toLowerCase().includes(termo) ||
      p.codigo?.toLowerCase().includes(termo)
    )
  }
  
  return produtos.sort((a, b) => (a.nome || '').localeCompare(b.nome || ''))
}

export async function getProduto(id) {
  return await db.produtos.get(id)
}

export async function addProduto(data) {
  const id = data.id || crypto.randomUUID()
  await db.produtos.add({
    ...data,
    id,
    status: 'ativo',
    criadoEm: Date.now(),
    atualizadoEm: Date.now(),
    pendingSync: 1 // Marcar para sincronizar com Supabase
  })
  return id
}

export async function updateProduto(id, data) {
  await db.produtos.update(id, {
    ...data,
    atualizadoEm: Date.now(),
    pendingSync: 1 // Marcar para sincronizar com Supabase
  })
}

export async function deleteProduto(id) {
  await db.produtos.update(id, {
    status: 'inativo',
    atualizadoEm: Date.now(),
    pendingSync: 1 // Marcar para sincronizar com Supabase
  })
}

// ============= FUNCIONÁRIOS =============

export async function listFuncionarios({ q = '', status = 'ativo' } = {}) {
  let query = db.funcionarios.toCollection()
  
  if (status !== 'todos') {
    query = query.filter(f => f.status === status)
  }
  
  let funcionarios = await query.toArray()
  
  if (q) {
    const termo = q.toLowerCase()
    funcionarios = funcionarios.filter(f =>
      f.nome?.toLowerCase().includes(termo) ||
      f.matricula?.toLowerCase().includes(termo)
    )
  }
  
  return funcionarios.sort((a, b) => (a.nome || '').localeCompare(b.nome || ''))
}

export async function addFuncionario(data) {
  const id = data.id || crypto.randomUUID()
  await db.funcionarios.add({
    ...data,
    id,
    status: 'ativo',
    criadoEm: Date.now(),
    pendingSync: 1 // Marcar para sincronizar com Supabase
  })
  return id
}

export async function updateFuncionario(id, data) {
  await db.funcionarios.update(id, {
    ...data,
    atualizadoEm: Date.now(),
    pendingSync: 1 // Marcar para sincronizar com Supabase
  })
}

export async function deleteFuncionario(id) {
  await db.funcionarios.update(id, {
    status: 'inativo',
    atualizadoEm: Date.now(),
    pendingSync: 1 // Marcar para sincronizar com Supabase
  })
}

// ============= MOVIMENTAÇÕES =============

export async function listMovimentacoes({ funcionarioId = null, limit: maxResults = 100 } = {}) {
  let query = db.movimentacoes.toCollection()
  
  if (funcionarioId) {
    query = query.filter(m => m.funcionarioId === funcionarioId)
  }
  
  const movimentacoes = await query.toArray()
  return movimentacoes
    .sort((a, b) => (b.dataMovimentacao || 0) - (a.dataMovimentacao || 0))
    .slice(0, maxResults)
}

export async function addMovimentacao(data) {
  const id = data.id || crypto.randomUUID()
  await db.movimentacoes.add({
    ...data,
    id,
    dataMovimentacao: Date.now(),
    status: 'ativa',
    pendingSync: 1 // Marcar para sincronizar com Supabase
  })
  return id
}

// ============= PEDIDOS =============

export async function getPedidoAtivo() {
  return await db.pedidosAtivo.get('ativo')
}

export async function setPedidoAtivo(data) {
  await db.pedidosAtivo.put({
    ...data,
    id: 'ativo',
    atualizadoEm: Date.now(),
    pendingSync: 1 // Marcar para sincronizar com Supabase
  })
}

export async function deletePedidoAtivo() {
  await db.pedidosAtivo.delete('ativo')
}

export async function listPedidosArquivados({ limit: maxResults = 50 } = {}) {
  const pedidos = await db.pedidosArquivados.toArray()
  return pedidos
    .sort((a, b) => (b.dataArquivamento || 0) - (a.dataArquivamento || 0))
    .slice(0, maxResults)
}

export async function arquivarPedido(pedido) {
  const id = pedido.id || crypto.randomUUID()
  await db.pedidosArquivados.add({
    ...pedido,
    id,
    dataArquivamento: Date.now(),
    pendingSync: 1 // Marcar para sincronizar com Supabase
  })
  return id
}

// ============= COMPRAS =============

export async function listComprasPendentes() {
  const compras = await db.comprasPendentes.toArray()
  return compras.sort((a, b) => (b.dataCriacao || 0) - (a.dataCriacao || 0))
}

export async function addCompraPendente(data) {
  const id = data.id || crypto.randomUUID()
  await db.comprasPendentes.add({
    ...data,
    id,
    dataCriacao: Date.now(),
    status: 'pendente',
    pendingSync: 1 // Marcar para sincronizar com Supabase
  })
  return id
}

export async function updateCompraPendente(id, data) {
  await db.comprasPendentes.update(id, {
    ...data,
    atualizadoEm: Date.now(),
    pendingSync: 1 // Marcar para sincronizar com Supabase
  })
}

export async function deleteCompraPendente(id) {
  await db.comprasPendentes.delete(id)
}

export async function addHistoricoCompra(data) {
  const id = data.id || crypto.randomUUID()
  await db.historicoCompras.add({
    ...data,
    id,
    dataFinalizacao: Date.now(),
    pendingSync: 1 // Marcar para sincronizar com Supabase
  })
  return id
}

// ============= AUDIT LOGS =============

export async function addAuditLog(data) {
  const id = data.id || crypto.randomUUID()
  await db.auditLogs.add({
    ...data,
    id,
    dataHora: Date.now()
  })
  return id
}

export async function listAuditLogs({ limit: maxResults = 100 } = {}) {
  const logs = await db.auditLogs.toArray()
  return logs
    .sort((a, b) => (b.dataHora || 0) - (a.dataHora || 0))
    .slice(0, maxResults)
}

// ============= SETTINGS =============

export async function getSetting(key) {
  const setting = await db.settings.get(key)
  return setting?.value
}

export async function setSetting(key, value) {
  await db.settings.put({
    key,
    value,
    atualizadoEm: Date.now()
  })
}

// ============= COUNTERS =============

export async function getNextNumber(tipo) {
  const counter = await db.counters.get(tipo)
  const nextNum = ((counter?.value || 0) + 1)
  await db.counters.put({
    id: tipo,
    value: nextNum,
    atualizadoEm: Date.now()
  })
  return nextNum
}

// ============= REALTIME (fallback polling) =============

export function onProdutosChange(callback) {
  const interval = setInterval(async () => {
    const produtos = await listProdutos()
    callback(produtos)
  }, 5000)
  return () => clearInterval(interval)
}

export function onComprasChange(callback) {
  const interval = setInterval(async () => {
    const compras = await listComprasPendentes()
    callback(compras)
  }, 5000)
  return () => clearInterval(interval)
}

export function onPedidoAtivoChange(callback) {
  const interval = setInterval(async () => {
    const pedido = await getPedidoAtivo()
    callback(pedido)
  }, 3000)
  return () => clearInterval(interval)
}

// ============= BACKUP / EXPORT =============

export async function exportAllData() {
  return {
    exportedAt: new Date().toISOString(),
    version: '1.0-local',
    data: {
      users: await db.users.toArray(),
      produtos: await db.produtos.toArray(),
      funcionarios: await db.funcionarios.toArray(),
      movimentacoes: await db.movimentacoes.toArray(),
      pedidosAtivo: await db.pedidosAtivo.toArray(),
      pedidosArquivados: await db.pedidosArquivados.toArray(),
      comprasPendentes: await db.comprasPendentes.toArray(),
      historicoCompras: await db.historicoCompras.toArray(),
      auditLogs: await db.auditLogs.toArray(),
      settings: await db.settings.toArray(),
      counters: await db.counters.toArray()
    }
  }
}


